import { render } from "./CreditDialog.vue?vue&type=template&id=2685c21e&scoped=true"
import script from "./CreditDialog.vue?vue&type=script&lang=js"
export * from "./CreditDialog.vue?vue&type=script&lang=js"

import "./CreditDialog.vue?vue&type=style&index=0&id=2685c21e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2685c21e"]])

export default __exports__